import { useAuthStore } from '@/store/useAuthStore';

/**
 * The one rule for whether a failure screen offers "Back to dashboard" (#1339,
 * owner Q-374 a). A person with no session lands on sign-in at `/` and loses
 * the share link they came in on, so their only exit is Try again.
 *
 * Every host of `FailureScreen` calls this at render time and passes
 * `onDashboard` only when it returns true. A new host must use it too:
 * `__tests__/failureScreenHosts.guard.test.ts` lists the known hosts.
 */
export function offersDashboardExit(): boolean {
  return useAuthStore.getState().isAuthenticated;
}
